module.exports = "<span ng-bind=\"$parent.row.activation.deterministic.activated_date | date:'MMM d, y'\"></span>"